const Text = () => {
return(
    <section className="md:py-[200px] py-20 px-5 md:px-[40px] text-center">
<blockquote className="font-canela font-light md:text-4xl text-3xl text-offBlack mb-5 leading-snug">‘Siempre hay algo de belleza en la sencillez.’</blockquote>
<cite className="block font-suisse font-medium not-italic text-sm tracking-wide text-offBlack">A.A. Milne</cite>
    </section>
)
}

export default Text;
